module.exports = __webpack_public_path__ + "static/USLPA_Media_Kit-5f6966ed7ed1558d9bef5711adf8aedc.pdf";